import { Button, Modal, Typography } from 'antd';
import { ExclamationCircleFilled } from '@ant-design/icons';
import React, { useState, useEffect } from 'react';
import '../../../styles/components/MarketPlace/MarketplaceModals.scss';
import { Routes } from '../../../constants/RouterConstants';
import { Navigation } from '../../../services/NavigationService';
import { jobTypes } from '../../../constants/MarketplaceConstants';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const { Text } = Typography;

function ForceUpdatePopup({ open, close }) {
  const history = useHistory();
  const { t } = useTranslation();

  const redirectToPlaystore = () => {};

  useEffect(() => {}, []);

  return (
    <Modal
      closable={false}
      visible={open}
      // onCancel={close}
      footer={null}
      className='unapplicable-jobs-modal'
      maskClosable={false}
    >
      <div className='duplicate-application-popup'>
        <div className='exclamation-container'>
          <ExclamationCircleFilled
            style={{ fontSize: '40px', color: '#D34B18' }}
          />
          <Text className='highlighted-information' style={{textAlign: 'center'}}>
            {'Please update the app'}
          </Text>
        </div>

        <Text className='other-op-text'>
          {
            'Your app needs to be updated. Please click on the button below to update it now.'
          }
        </Text>
        <a href='https://play.google.com/store/apps/details?id=com.vahan.mitra_playstore&ddl=1&pcampaignid=web_ddl_1' rel="noreferrer" target="_blank">
          <Button
            className='get-started-button primary-cta'
          >
            <Text className='get-started-text'>Update app</Text>
          </Button>
        </a>
      </div>
    </Modal>
  );
}

export default ForceUpdatePopup;
